!((document, Drupal, $, drupalSettings) => {

  'use strict';

  /**
   * Handle anchors node loisirs ch
   */
  Drupal.behaviors.nodeLoisirs = {

    attach: function(context, settings) {

      $(context).find('.anchor-container').each(function () {
        const tabLinks = $(this).find('a[data-action-id]'); // Select all <a> elements with data-action-id attribute

        tabLinks.on('click', function (event) {
          let dataActionId = $(this).data('action-id'); // Get the value of data-action-id attribute
          history.pushState(null, null, '#' + dataActionId);
        });

        let initialFragment = window.location.hash.substring(1);
        if (initialFragment) {
          let initialTabLink = $(this).find('a[data-action-id="' + initialFragment + '"]');
          if (initialTabLink.length > 0) {
            // remove class uk-active for each tablinks and add to the good one
            tabLinks.each(function () {
              if($(this).attr('data-action-id') !== initialFragment){
                $(this).parent().removeClass('uk-active');
              }
              else{
                $(this).parent().addClass('uk-active');
              }
            });
          }
        }
      });

      var observeDOM = (function(){
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

        return function( obj, callback ){
          if( !obj || obj.nodeType !== 1 ) return;

          if( MutationObserver ){
            // define a new observer
            var mutationObserver = new MutationObserver(callback)

            // have the observer observe for changes in children
            mutationObserver.observe( obj, { childList:true, subtree:true })
            return mutationObserver
          }

          // browser support fallback
          else if( window.addEventListener ){
            obj.addEventListener('DOMNodeInserted', callback, false)
            obj.addEventListener('DOMNodeRemoved', callback, false)
          }
        }
      })()


      observeDOM( document.querySelector('#ritr_container'), function(m){
        $(once('destSet', '#HFS_ToContainer input', document)).val(drupalSettings.stopName);
      });

    }

  };
// eslint-disable-next-line no-undef
})(document, Drupal, jQuery, drupalSettings);
